import { useMemo } from 'react'
import { OnboardingStepOption } from '../types'

type Props = {
  values: any
  options: OnboardingStepOption[]
}

export const useSteps = ({ values, options = [] }: Props) => {
  const steps = useMemo(() => {
    return options.filter(option => option.isVisible?.(values) ?? true)
  }, [options, values])

  return {
    steps,
  }
}
